import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import './Jobposting.css';
import { constants } from './Constant';

const Jobposting = () => {
    const [openAccordion, setOpenAccordion] = useState(null);
    const [email, setEmail] = useState('');
    const [resume, setResume] = useState(null);

    const toggleAccordion = (jobId) => {
        setOpenAccordion(openAccordion === jobId ? null : jobId);
    };

    const handleFileChange = (e) => setResume(e.target.files[0]);

    // const handleSubmit = (e, selectedJob) => {
    //     e.preventDefault();

    //     if (!email || !resume) {
    //         alert('Error: Please provide both email and resume.');
    //         return;
    //     }

    //     const subject = encodeURIComponent(`Job Application for ${selectedJob.title}`);
    //     const body = encodeURIComponent(
    //         `Job Title: ${selectedJob.title}\nDescription: ${selectedJob.description}\nEmail: ${email}\nResume: ${resume.name}`
    //     );

    //     const mailtoLink = `mailto:hr@company.com?subject=${subject}&body=${body}`;

    //     window.location.href = mailtoLink;
    // };

    return (
        <>
            <Header />
            <div
                id="myDIV"
                style={{
                    backgroundImage: `url(${require('../assets/images/meetings-bg.jpg')})`,
                    padding: '50px',
                    color: 'white',
                }}
            >
                <div className="row">
                    <div className="col-lg-12">
                        <div className="caption caption-content">
                            <h2 style={{ paddingBottom: "10px", paddingTop: '40px', color: 'white', margin: '20px' }}>
                                {constants?.Jobpost.title}
                            </h2>

                            {constants?.Jobposting.map((jobItem, index) => (
                                <div className="accordion-container" key={index}>
                                    <div
                                        className="accordion-header"
                                        onClick={() => toggleAccordion(index)}
                                    >
                                        <h3>{jobItem.title}</h3>
                                        <span style={{ marginLeft: '10px' }}>
                                            {openAccordion === index ? '▲' : '▼'}
                                        </span>
                                    </div>

                                    {openAccordion === index && (
                                        <div className="accordion-content">
                                            <form id={"formId"+index+1} name={"formName"+index+1}>

                                                <div className="form-group" style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
                                                    <label>{constants?.Jobpost.descriptionText}</label>
                                                    <p>{jobItem.description}</p>
                                                </div>
                                                {/*<div className="form-group" style={{ display: 'flex', justifyContent: 'center'}}>
                                                    <label style={{ display: 'flex', justifyContent: 'center',alignItems:'center'}}>{constants?.Jobpost.emailText}</label>
                                                    <input
                                                        type="email"
                                                        style={{ width: '400px',margin:'10px'}}
                                                        className="form-control"
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)}
                                                        required
                                                    />
                                                </div>

                                                <div className="form-group" style={{ display: 'flex', justifyContent: 'center' }}>
                                                    <label style={{ display: 'flex', justifyContent: 'center',alignItems:'center'}}>{constants?.Jobpost.attachCvText}</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        style={{ width: '400px' ,margin:'10px'}}
                                                        accept=".pdf,.doc,.docx"
                                                        onChange={handleFileChange}
                                                        required
                                                    />
                                                </div>
                                                <center>
                                                <button type="submit" className="btn-primary">
                                                {constants?.Jobpost.btnSubmitText}
                                                </button>
                                                </center>*/}
                                            </form>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Jobposting;
